import { createI18n } from 'vue-i18n'
import fa from './locales/fa'
import en from './locales/en'

export const i18n = createI18n({
  legacy: false, 
  locale: 'fa',
  fallbackLocale: 'en',
  messages: {
    fa,
    en,
  },
})
